<template>
  <div
    v-if="showSku || showPoints"
    class="ns-product-sku-points"
    :class="{ 'ns-product-sku-points__product-detail': isProductDetail }"
  >
    <div v-if="showSku" class="ns-product-sku-points__sku" itemprop="sku">
      {{ translations.item }} # {{ sku }}
    </div>
    <div
      v-if="showPoints"
      class="ns-product-sku-points__points"
      :class="{ 'ns-product-sku-points__hide-before': !showSku }"
    >
      {{ translations.psv }}:
      <span class="ns-product-sku-points__points-min" data-testid="sv">
        {{ fixedPoints }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "NsProductSkuPoints",
  props: {
    /**
     * Will show points even if not distributor
     */
    forcesv: Boolean,
    /**
     * Will hide sku
     */
    hideSku: Boolean,
    /**
     * True if use is distributor
     */
    isDistributor: Boolean,
    /**
     * The amount of points
     */
    points: {
      type: String,
      default: null
    },
    /**
     * True if parent is ProductDetail
     */
    isProductDetail: Boolean,
    /**
     * The sku
     */
    sku: {
      type: String,
      default: ""
    },
    /**
     * The translations
     */
    translations: {
      type: Object,
      default() {
        return {
          item: "Item",
          psv: "Points"
        };
      }
    }
  },
  computed: {
    fixedPoints() {
      return parseFloat(this.points).toFixed(2);
    },
    showSku() {
      return !this.hideSku;
    },
    showPoints() {
      return this.points && (this.isDistributor || this.forcesv);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.ns-product-sku-points {
  display: grid;
  grid-gap: 20px;
  grid-auto-flow: column;
  justify-content: center;

  &.ns-product-sku-points__product-detail {
    .ns-product-sku-points__sku {
      font-weight: map.get(typographyVariables.$typography, font-weight-medium);
    }
  }
}

.ns-product-sku-points__sku {
  color: map.get(colors.$themeColors, color-interactive-8);
  @extend .p-small;
}

.ns-product-sku-points__points {
  position: relative;
  color: map.get(colors.$themeColors, color-interactive-8);

  &.ns-product-sku-points__hide-before::before {
    display: none;
  }
}

.ns-product-sku-points__points::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 1px;
  height: 10px;
  background-color: map.get(colors.$themeColors, color-gray-1);
}

.ns-product-sku-points__points-min {
  color: map.get(colors.$themeColors, color-interactive-8);
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
}
</style>
